import { ProductWizardType, WizardData } from '../../types'

export type ProcoteWizardDataProps = {
  categoryName: string | null
  expectedYield: number
  fertilizer: number
  acres: number
  litresPerTonne: number
  haveFertilizer: boolean
  yieldUnit: string
  steps: string[]
  productId?: string | null
  productName?: string | null

  //sku only
  cardId?: string | null
  skuId?: string | null
  cardTitle?: string | null
}

export const getProcoteWizardData = ({
  categoryName,
  expectedYield,
  fertilizer,
  acres,
  litresPerTonne,
  haveFertilizer,
  yieldUnit,
  productId,
  productName,
  cardId,
  skuId,
  cardTitle,
  steps,
}: ProcoteWizardDataProps): WizardData<ProductWizardType.Procote, any> => ({
  type: ProductWizardType.Procote,
  steps,
  params: {},
  sku_params: {
    expected_yield_unit: yieldUnit,
    litres_per_tonne: litresPerTonne,
    category_name: categoryName,
    fertilizer: fertilizer,
    expected_yield: expectedYield,
    acres: acres,
    has_purchased_fertilizer: haveFertilizer,
    ...(cardId
      ? { card_id: cardId, sku_id: skuId, card_title: cardTitle }
      : { product_id: productId, product_name: productName }),
  },
})
